import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";

export const QuestionnaireReport = async (
  startDate?: string,
  endDate?: string
) => {
  const dataAPI = await HttpService.post(
    ApiService.questionnaire.questionnaireReport,
    JSON.stringify({
      StartDateString: startDate,
      EndDateString: endDate,
    })
  );

  return dataAPI;
};
